export const REGISTRATION_RESET = 'cricket/Registration/REGISTRATION_RESET';
